import {Component, EventEmitter, Inject, Input, LOCALE_ID, OnInit, Output, ViewChild} from '@angular/core';

import {Document, Image, ImageService, PageService} from '../../common/services';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '../../../common/widgets/general/data-table';
import {MatDataSourceGeneric} from '../../../common/core/services/base/daoService';
import {FileSizePipe} from '../../../common/widgets/pipes/file-size';

import { MatDialog } from '@angular/material/dialog';
import {ImagePreviewComponent} from './image-preview/image-preview.component';
import {DialogData, DialogValidationComponent} from '../../../common/widgets/general/dialog-validation';
import {PageListModalComponent} from '../pages/page-list-modal/page-list-modal.component';
import {ImageAddModaleComponent} from './image-add-modale/image-add-modale.component';
import {ActivatedRoute, Router} from '@angular/router';
import {DatePipe} from '@angular/common';


@Component({
  selector: 'p8-bdc-images',
  templateUrl: './images.component.html',
  styleUrls: ['./images.component.scss']
})
export class ImagesComponent implements OnInit {
  @Input() selectingMode = false;

  @Output() imageSelected = new EventEmitter<Image>();

  dsImages: MatDataSourceGeneric<Image> = new MatDataSourceGeneric<Image>();
  @ViewChild(DataTableComponent, { static: true }) dataTable: DataTableComponent;

  extraParams: Map<string, string> = new Map<string, string>();

  columns: ColumnDataTable[] = [
    { columnDef: 'title', header: 'Titre', display: (image: Image) => {
       return image.title;
      } , sort: true, hidden: false, truncate: true },

    { columnDef: 'filename', header: 'Nom du fichier', display: (image: Image) => {
        return image.filename;
      } , sort: false, hidden: false, truncate: true, flex: 20 },

    { columnDef: 'dt_updated', header: 'Modification', display: (image: Image) => {
        const dp: DatePipe = new DatePipe(this.locale);
        return dp.transform(`${image.dt_updated}`, 'dd/MM/yyyy H:mm');
      } , sort: true, hidden: false, flex: 13 },

    { columnDef: 'size', header: 'Taille', display: (image: Image) => {
        const fs = new FileSizePipe(this.locale);

        return fs.transform(image.size, 2, this.locale);
      } , sort: false, hidden: false, flex: 10 },
    { columnDef: 'file', header: 'Miniature', display: (image: Image) => {
        return `<img src="${image.file}" width="50"/>`;
      } , sort: false, hidden: false, flex: 10 },
    { columnDef: 'nb_pages', header: 'Pages', display: (doc: Document) => {
        return doc.nb_pages;
      } , sort: false, hidden: false, flex: 5 },
  ];

  actions: ActionDataTable[] = [
    { label: 'Sélectionner', tooltip: 'Sélectionner l\'image pour l\'ajouter à la page',  icon: 'add_circle_outline',
      click: (image: Image) => this.selection(image), flex: 4,
      hidden: (row: Image) => !this.selectingMode
    },

    { label: 'Pages', tooltip: 'Voir la liste des pages associées',  icon: 'pageview',
      click: (img: Image) => this.listePages(img), flex: 5,
      hidden: (row: Image) => {
        return this.selectingMode || row.nb_pages === 0;
      }},

    { label: 'Modifier', tooltip: 'Modifier les informations de l\'image',  icon: 'edit',
      click: (image: Image) => this.modifier(image), flex: 6,
      hidden: (row: Image) => {
        return this.selectingMode;
      } },

    { label: 'Supprimer', tooltip: 'Supprimer l\'image de la bibliothèque',  icon: 'delete',
      click: (image: Image) => this.supprimer(image), flex: 6,
      hidden: (row: Image) => {
        return this.selectingMode || row.nb_pages > 0;
      } },

    { label: 'Visualiser', tooltip: 'Visualier l\'image',  icon: 'remove_red_eye',
      click: (image: Image) => this.visualiser(image), flex: 6, },
  ];

  maxItems = 10;

  constructor(@Inject(LOCALE_ID) private locale: string,
              private imageService: ImageService,
              private pagesSvc: PageService,
              private activatedRoute: ActivatedRoute,
              private router: Router,
              private dialog: MatDialog) {
    this.dsImages.daoService = imageService;
  }

  ngOnInit() {
    if (this.selectingMode) {
      this.maxItems = 5;
    }
  }

  visualiser(image: Image) {
    const modal = this.dialog.open(ImagePreviewComponent, {data: {file: image.file, id: image.id}});
    modal.updatePosition({top: '50px'});
  }

  selection(image: Image) {
    this.imageSelected.emit(image);
  }

  modifier(image: Image) {
    this.router.navigate([image.id, 'edit'], {relativeTo: this.activatedRoute});
  }

  supprimer(image: Image) {
    const data = new DialogData();
    data.title = 'Supprimer image';
    data.message = `Souhaitez-vous supprimer l'image <b>${image.title}</b> de la bibliothèque ?`;
    data.buttonTextTrue = 'SUPPRIMER';
    data.buttonTextFalse = 'ANNULER';
    data.buttonColorTrue = 'warn';
    data.buttonColorFalse = '';

    const modalConfirm = this.dialog.open(DialogValidationComponent, { data: data, disableClose: true});
    modalConfirm.updatePosition({top: '100px'});
    modalConfirm.afterClosed().subscribe(confirm => {
      if (confirm === true) {
        this.imageService.delete(image).subscribe(() => {
          this.dataTable.reload();
        });
      }
    });
  }

  listePages(img: Image) {
    const by_img: Map<string, string> = new Map<string, string>();

    by_img.set('by_image', img.id.toString());
    this.pagesSvc.listAll(by_img).subscribe((pages) => {
      const modalPages = this.dialog.open(PageListModalComponent, { data: pages });
      modalPages.updatePosition({top: '100px'});
      // modalPages.updateSize('600px', '500px');
    });
  }

  openAddModaleImages() {
    const modal = this.dialog.open(ImageAddModaleComponent, );
    modal.updatePosition({top: '50px'});
    modal.updateSize('1200px');

    modal.afterClosed().subscribe((added: boolean) => {
      if (added) {
        this.dataTable.reload();
      }
    });
  }
}
